import { PasswordValidationRule } from "../models/form.model";

export const validatePassword: PasswordValidationRule[] = [
    {
        key: 'min8',
        status: false,
        text: 'Minimum 8 characters',
        error: '8 karakter',
      },
      {
        key: 'minCapital',
        status: false,
        text: 'Minimum 1 capital letter A-Z',
        error: '1 huruf besar',
      },
      {
        key: 'minText',
        status: false,
        text: 'Minimum 1 lowercase letter a-z',
        error: '1 huruf kecil',
      },
      {
        key: 'minNum',
        status: false,
        text: 'Minimum 1 digit 0-9',
        error: '1 angka',
      },
      {
        key: 'minChar',
        status: false,
        text: "Minimum 1 of the following symbols: ` ~ !  ( ) - + _ = { [ ] } : ; ' . < > /",
        error: '1 symbol',
      },
      { key: 'maxChar', status: false, error: 'Maximum 32 characters' },
    ]
